// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2NNgL","item":"Footer_item__1aDSo"};